import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { partnerClientActions } from '../actions/partner-client.actions';
import { ICreatePartnerClientBody, IPartnerClient } from '../models/outbound/partner-client.model';
import {
    selectPartnerClients,
    selectPartnerClientsError,
    selectPartnerClientsLoading,
    selectPartnerClientsMutating,
} from '../selectors/partner-client.selectors';

/** Pages consume this; never reach into the Store directly. */
@Injectable({ providedIn: 'root' })
export class PartnerClientProvider {
    public constructor(private readonly store: Store) {}

    public getClients$(): Observable<IPartnerClient[]> {
        return this.store.select(selectPartnerClients);
    }

    public isLoading$(): Observable<boolean> {
        return this.store.select(selectPartnerClientsLoading);
    }

    public isMutating$(): Observable<boolean> {
        return this.store.select(selectPartnerClientsMutating);
    }

    public getError$(): Observable<string | null> {
        return this.store.select(selectPartnerClientsError);
    }

    public loadClients(): void {
        this.store.dispatch(partnerClientActions.loadClients());
    }

    public createClient(body: ICreatePartnerClientBody): void {
        this.store.dispatch(partnerClientActions.createClient({ body }));
    }

    public rotateSecret(id: string): void {
        this.store.dispatch(partnerClientActions.rotateSecret({ id }));
    }

    public revokeClient(id: string): void {
        this.store.dispatch(partnerClientActions.revokeClient({ id }));
    }
}
